import { uniqueId } from 'lodash';
import { MenuPermission } from '@/types';

export interface MenuitemsType {
  [x: string]: any;
  id?: string;
  navlabel?: boolean;
  subheader?: string;
  title?: string;
  icon?: any;
  href?: string;
  children?: MenuitemsType[];
  chip?: string;
  chipColor?: string;
  variant?: string;
  external?: boolean;
  permission?: MenuPermission;
}
import {
  IconDashboard,
  IconFileText,
  IconTicket,
  IconShield,
  IconUsers,
  IconBulb,
  IconUsersGroup,
  IconTag,
  IconHistory,
  IconCreditCard,
  IconShoppingCart,
  IconCalendar,
  IconPackage,
  IconEdit,
  IconKey,
  IconUser,
  IconCar,
  IconCodeCircle,
  IconWiperWash,
  IconBuildingStore,
  IconPlus,
} from '@tabler/icons-react';

const Menuitems: MenuitemsType[] = [
  {
    navlabel: true,
    subheader: ' ',
  },

  {
    id: uniqueId(),
    title: 'Dashboard',
    icon: IconDashboard,
    href: '/dashboard',
    permission: {
      userTypes: ['admin', 'customer'],
    },
  },
  {
    id: uniqueId(),
    title: 'New file',
    icon: IconPlus,
    href: '/new-file-service',
    permission: {
      userTypes: ['customer'],
    },
  },
  {
    id: uniqueId(),
    title: 'File Service',
    icon: IconFileText,
    href: '/file-service',
    permission: {
      userTypes: ['admin', 'customer'],
      resourceName: 'File service',
    },
  },
  {
    id: uniqueId(),
    title: 'Tickets',
    icon: IconTicket,
    href: '/tickets',
    permission: {
      userTypes: ['admin', 'customer'],
      resourceName: 'Support',
    },
  },
  {
    id: uniqueId(),
    title: 'Roles',
    icon: IconShield,
    href: '/roles',
    permission: {
      userTypes: ['admin'],
      resourceName: 'Roles',
    },
  },
  {
    id: uniqueId(),
    title: 'Employees',
    icon: IconUsers,
    href: '/employees',
    permission: {
      userTypes: ['admin'],
      resourceName: 'Employees',
    },
  },
  {
    id: uniqueId(),
    title: 'Solutions category',
    icon: IconBulb,
    href: '/solutions/category',
    permission: {
      userTypes: ['admin'],
      resourceName: 'Solutions',
    },
  },
  {
    id: uniqueId(),
    title: 'Solutions',
    icon: IconBulb,
    href: '/solutions',
    permission: {
      userTypes: ['admin', 'customer'],
      resourceName: 'Solutions',
    },
  },
  // {
  //   id: uniqueId(),
  //   title: 'Scripts',
  //   icon: IconCode,
  //   href: '/scripts',
  //   permission: {
  //     userTypes: ['admin'],
  //   },
  // },
  // {
  //   id: uniqueId(),
  //   title: 'Slave Decode & Encode',
  //   icon: IconSettings,
  //   href: '/slave-decode-encode',
  //   permission: {
  //     userTypes: ['admin'],
  //   },
  // },
  {
    id: uniqueId(),
    title: 'Customers',
    icon: IconUsersGroup,
    href: '/customers',
    permission: {
      userTypes: ['admin'],
      resourceName: 'Customers',
    },
  },
  {
    id: uniqueId(),
    title: 'Customer Types',
    icon: IconTag,
    href: '/customer-types',
    permission: {
      userTypes: ['admin'],
      resourceName: 'Customer types',
    },
  },
  {
    id: uniqueId(),
    title: 'Customer Groups',
    icon: IconUsersGroup,
    href: '/customer-groups',
    permission: {
      userTypes: ['admin'],
      resourceName: 'Customer types',
    },
  },
  // {
  //   id: uniqueId(),
  //   title: 'Prices category',
  //   icon: IconCurrencyDollar,
  //   href: '/prices/category',
  //   permission: {
  //     userTypes: ['admin'],
  //     resourceName: 'Prices',
  //   },
  // },
  // {
  //   id: uniqueId(),
  //   title: 'Prices',
  //   icon: IconCurrencyDollar,
  //   href: '/prices',
  //   permission: {
  //     userTypes: ['admin'],
  //     resourceName: 'Prices',
  //   },
  // },
  {
    id: uniqueId(),
    title: 'Order History',
    icon: IconHistory,
    href: '/order-history',
    permission: {
      userTypes: ['admin', 'customer'],
      resourceName: 'Order history',
    },
  },
  // {
  //   id: uniqueId(),
  //   title: 'Purchase Invoices',
  //   icon: IconReceipt,
  //   href: '/purchase-invoices',
  //   permission: {
  //     userTypes: ['admin'],
  //   },
  // },
  {
    id: uniqueId(),
    title: 'Credit Transaction',
    icon: IconCreditCard,
    href: '/credit-transaction',
    permission: {
      userTypes: ['admin', 'customer'],
      resourceName: 'Credit transactions',
    },
  },
  {
    id: uniqueId(),
    title: 'Shop',
    icon: IconShoppingCart,
    href: '/shop',
    permission: {
      userTypes: ['customer'],
    },
  },
  {
    id: uniqueId(),
    title: 'Schedule',
    icon: IconCalendar,
    href: '/schedule',
    permission: {
      userTypes: ['admin'],
      resourceName: 'Schedule',
    },
  },
  {
    id: uniqueId(),
    title: 'Credit Packages',
    icon: IconPackage,
    href: '/credit-packages',
    permission: {
      userTypes: ['admin'],
      resourceName: 'Credit packages',
    },
  },
  {
    id: uniqueId(),
    title: 'Notice Editor',
    icon: IconEdit,
    href: '/notice-editor',
    permission: {
      userTypes: ['admin'],
      resourceName: 'Notice',
    },
  },
  {
    id: uniqueId(),
    title: 'Credentials Management',
    icon: IconKey,
    href: '/credentials-management',
    permission: {
      userTypes: ['admin'],
      resourceName: 'Credentials',
    },
  },
  {
    id: uniqueId(),
    title: 'Company Info',
    icon: IconBuildingStore,
    href: '/company-info',
    permission: {
      userTypes: ['admin'],
      resourceName: 'Company info',
    },
  },
  {
    id: uniqueId(),
    title: 'Autodata',
    icon: IconCar,
    href: '/autodata',
    permission: {
      userTypes: ['customer'],
    },
  },
  {
    id: uniqueId(),
    title: 'P-Codes',
    icon: IconCodeCircle,
    href: '/p-codes',
    permission: {
      userTypes: ['customer'],
    },
  },
  {
    id: uniqueId(),
    title: 'Bosh codes',
    icon: IconWiperWash,
    href: '/bosh-codes',
    permission: {
      userTypes: ['customer'],
    },
  },
  {
    id: uniqueId(),
    title: 'Profile',
    icon: IconUser,
    href: '/profile',
    permission: {
      userTypes: ['admin', 'customer'],
    },
  },
  {
    id: uniqueId(),
    title: 'Terms & Conditions',
    icon: IconFileText,
    href: '/terms-of-use',
    permission: {
      userTypes: ['customer'],
    },
  },
];

export default Menuitems;
